import { useContext, useEffect, useState } from "react";
import styles from "./Navigation.module.css";
import exit from "../../assets/x-highlight.png";
import LanguageChange from "../UI/LanguageChange";
import { Link, div, useNavigate } from "react-router-dom";
import DataContext from "../store/data-context";
import arrow from "../../assets/arrow-highlight.png";
import useScrollStop from "../hooks/use-scroll-stop";
import NavigationContext from "../store/navigation-context";
import Button from "../UI/Button";

const catalogues = [
  "katalog df sadsf",
  "katalog df sadsf",
  "katalog df sadsf",
  "katalog df sadsf",
  "katalog df sadsf",
  "katalog df sadsf",
  "katalog df sadsf",
  "katalog df sadsf",
  "katalog df sadsf",
];

export default function Navigation({ onClose, dataCtx }) {
  const [cataloguesOpen, setCataloguesOpen] = useState(false);
  const navCtx = useContext(NavigationContext);
  const navigate = useNavigate();

  useScrollStop();

  const navigateHandler = (e) => {
    const to = e.target.getAttribute("value");
    navigate(to);
    onClose();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} />
      <main className={styles.main}>
        <img className={styles.exit} src={exit} alt="X" onClick={onClose} />

        <div className={styles[`list`]}>
          <div
            to={`/${dataCtx.lang.lang}`}
            value={`/${dataCtx.lang.lang}`}
            onClick={navigateHandler}
            className={`${styles.home} ${
              styles[
                window.location.hash === `#/${dataCtx.lang.lang}` && `active`
              ]
            } ${styles.element} `}
          >
            {dataCtx.pageData.home.title}
          </div>
          <div
            value={dataCtx.lang.lang + "/" + dataCtx.pageData.market.title}
            onClick={navigateHandler}
            className={`${styles.home} ${styles.element} ${
              styles[
                window.location.hash ===
                  `#/${dataCtx.lang.lang}/${dataCtx.lang.market}` && `active`
              ]
            }`}
          >
            {dataCtx.pageData.market.title}
          </div>
          <div
            className={`${styles.home} ${styles.element}  ${
              styles[`catalogue-title`]
            } ${styles[cataloguesOpen && `element-active`]} ${
              styles[window.location.hash.includes("katalozi") && `active`]
            }`}
            onClick={() => {
              setCataloguesOpen((prevValue) => !prevValue);
            }}
          >
            {dataCtx.pageData.categories.nav_title}
            <img
              src={arrow}
              className={`${styles[`catalogue-arrow`]} ${
                styles[cataloguesOpen && `catalogue-arrow-active`]
              }`}
              alt=">"
            />
          </div>
          <div
            className={`${styles.catalogues} ${
              styles[cataloguesOpen && `catalogues-open`]
            }`}
          >
            {dataCtx.categories.map((e, i) => {
              return (
                <div
                  value={
                    "/" +
                    dataCtx.lang.lang +
                    "/" +
                    dataCtx.pageData.categories.nav_title + "/" +
                    e.acf.lang_url
                  }
                  key={i}
                  className={`${styles.element} ${styles.catalogue}`}
                  onClick={navigateHandler}
                >
                  {e.post_title}
                </div>
              );
            })}
          </div>
          <div
            value={dataCtx.lang.lang + "/" + dataCtx.pageData.references.title}
            className={`${styles.home} ${styles.element}`}
            onClick={navigateHandler}
          >
            {dataCtx.pageData.references.title}
          </div>
        </div>
        <div className={styles.language}>
          <Button
            onClick={() => {
              navCtx.setIsContacting(true);
            }}
          >
            Kontakt
          </Button>

          <LanguageChange isMobile={true} />
        </div>
      </main>
    </>
  );
}
